import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { ApplicationState } from '~/store';
import { ResponseProps } from '../../../utils/helper';
import {
  categoriaFailure,
  categoriaRequest,
  categoriaSuccess,
  companyAllFailure,
  companyAllRequest,
  companyAllSuccess,
  companyFailure,
  companyRequest,
  companySuccess,
} from './actions';
import { CommonTypes } from './types';

function* categorias({ payload }: ReturnType<typeof categoriaRequest>) {
  const { company } = yield select((state: ApplicationState) => state.auth);

  try {
    const response: ResponseProps = yield call(api.get, `/v1/categories`, {
      headers: {
        'content-type': 'application/json',
        company: company?.country_company_id,
      },
    });

    yield put(categoriaSuccess(response.data));
  } catch (error) {
    yield put(categoriaFailure());
  }
}

function* companyAll({ payload }: ReturnType<typeof companyAllRequest>) {
  try {
    const response: ResponseProps = yield call(api.get, `/v1/company/all`, {
      headers: {
        'content-type': 'application/json',
      },
    });

    yield put(companyAllSuccess(response.data));
  } catch (error) {
    yield put(companyAllFailure());
  }
}

function* company({ payload }: ReturnType<typeof companyRequest>) {
  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/company/alias?company=`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: '',
        },
      },
    );

    yield put(companySuccess(response.data));
  } catch (error) {
    //@ts-ignore
    yield (window.location = '/');
    yield put(companyFailure());
  }
}

export default all([
  takeLatest(CommonTypes.CATEGORIA_REQUEST, categorias),
  takeLatest(CommonTypes.COMPANY_ALL_REQUEST, companyAll),
  takeLatest(CommonTypes.COMPANY_REQUEST, company),
]);
